import {
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  Injector,
  Input,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DomPortalOutlet,
  PortalOutlet,
  TemplatePortal,
} from '@angular/cdk/portal';
import { Company } from '../../../core/models';
import { UserSubscription } from '../../../modules/auth';

@Component({
  selector: 'app-report-company-print',
  templateUrl: './report-company-print.component.html',
  styleUrls: ['./report-company-print.component.scss'],
})
export class ReportCompanyPrintComponent implements OnDestroy {
  @Input() title: string;
  @Input() data: Company[];
  @Input() subscription: UserSubscription | null;
  @ViewChild('iframe') iframe: any; // target host to render the printable content
  @ViewChild('reportTemplate') reportTemplateRef: any;
  private portalHost: PortalOutlet;

  constructor(
    public activeModal: NgbActiveModal,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private viewContainerRef: ViewContainerRef
  ) {}

  closeModal() {
    this.activeModal.dismiss('Cross click');
  }

  printNow() {
    const iframe = this.iframe.nativeElement;
    this.portalHost = new DomPortalOutlet(
      iframe.contentDocument.body,
      this.componentFactoryResolver,
      this.appRef,
      this.injector
    );

    const portal = new TemplatePortal(
      this.reportTemplateRef,
      this.viewContainerRef,
      {
        data_context: [],
      }
    );

    // Attach portal to host
    this.portalHost.attach(portal);
    iframe.contentWindow.onafterprint = () => {
      iframe.contentDocument.body.innerHTML = '';
    };

    this._attachStyles(iframe.contentWindow);

    this.waitForImageToLoad(iframe, () => iframe.contentWindow.print());
  }

  private waitForImageToLoad(iframe: HTMLIFrameElement, done: any): void {
    const interval = setInterval(() => {
      const allImages =
        // @ts-ignore
        iframe.contentDocument.body.querySelectorAll('img.card-image');
      const loaded = Array.from({ length: allImages.length }).fill(false);
      // @ts-ignore
      allImages.forEach((img: HTMLImageElement, idx) => {
        loaded[idx] = img.complete && img.naturalHeight !== 0;
      });
      if (loaded.every(c => c === true)) {
        clearInterval(interval);
        done();
      }
    }, 500);
  }

  private _attachStyles(targetWindow: Window): void {
    // Copy styles from parent window
    document.querySelectorAll('style').forEach(htmlElement => {
      targetWindow.document.head.appendChild(htmlElement.cloneNode(true));
    });
    // Copy stylesheet link from parent window
    const styleSheetElement = this._getStyleSheetElement();
    targetWindow.document.head.appendChild(styleSheetElement);
  }

  private _getStyleSheetElement() {
    const styleSheetElement = document.createElement('link');
    document.querySelectorAll('link').forEach(htmlElement => {
      if (htmlElement.rel === 'stylesheet') {
        const absoluteUrl = new URL(htmlElement.href).href;
        styleSheetElement.rel = 'stylesheet';
        styleSheetElement.type = 'text/css';
        styleSheetElement.href = absoluteUrl;
      }
    });
    return styleSheetElement;
  }

  ngOnDestroy(): void {
    if (this.portalHost) this.portalHost.detach();
  }
}
